module.exports = __webpack_public_path__ + "img/green_061.fa71e230.png";